import GroupAbc from '@/services/group_abc'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const fetchGroupTaxByPayer = async (context, id) => {
  return new Promise(async (resolve, reject) => {
    GroupAbc.taxByPayer(id)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const createGroupTax = (context, payload) => {
  return new Promise(async (resolve, reject) => {
    GroupAbc.create(payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(error.response.data)
        })
        reject(error)
      })
  })
}

const updateGroupTax = (context, payload) => {
  return new Promise(async (resolve, reject) => {
    GroupAbc.update(payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(error.response.data)
        })
        reject(error)
      })
  })
}

const deleteGroupTax = (context, payload) => {
  return new Promise(async (resolve, reject) => {
    GroupAbc.delete(payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(error.response.data)
        })
        reject(error)
      })
  })
}

export default {
  fetchGroupTaxByPayer,
  createGroupTax,
  updateGroupTax,
  deleteGroupTax
}



// WEBPACK FOOTER //
// ./src/features/abc/store/actions.js